// Module with helper functions
/**
 * Removes duplicates from array based on 'property'
 *
 * @param array
 * @param property: String
 * @returns array without duplicates
 */
export const removeDuplicatesFromArrayByProperty = (array, property) => {
    return array.reduce((acc, current) => {
        return acc.some(item => item[property] === current[property])
            ? acc
            : [...acc, current];
    }, []);
};

/**
 * Removes properties of object
 *
 * @param object
 * @param properties: String[]
 * @returns Object without removed properties
 */
export const removePropertiesFromObject = (object, properties) => {
    properties.forEach(prop => {
        delete object[prop];
    });
    return object;
};

/**
 * Checks if an object is empty
 *
 * @param object
 * @returns {boolean}
 */
export const objectIsEmpty = object => !Object.keys(object).length;

/**
 * Checks if an array is empty
 *
 * @param array
 * @returns {boolean}
 */
export const arrayIsEmpty = array => !array.length;

/**
 * Returns the passed in value if it's array, otherwise returns an empty array
 * @param {*} val
 */
export const getAsArray = val => Array.isArray(val) ? val : [];

/**
 * Sort asc by property
 *
 */
export const sortAscByProperty = (array, property) => {
    return array.sort((a, b) => a[property] < b[property] ? -1 : 1);
};

export const getLastModifiedList = (array) => {
    return array.sort((a, b) => a[1].sortId - b[1].sortId)[0][1].value;
};
/**
 * Returns the element of the array with the lowest value of "property"
 *
 * @param array
 * @param property
 * @returns {*}
 */
export const getMinimumElementFromArrayByProperty = (array, property) => {
    return array?.reduce((minEl, item) => {
        const prop = getNestedProp(item, property);
        const minElProp = getNestedProp(minEl, property);
        return prop < minElProp ? item : minEl;
    }, array[0]);
};

/**
 * Allows to access an object property in the format:
 * obj = { a: { b: 'value'}}
 * path = 'a.b'
 *
 * @param obj
 * @param path
 * @returns {*}
 */
export const getNestedProp = (obj, path) => {
    return path
        .split('.')
        .reduce((acc, part) => acc && acc[part], obj) ?? null;
};

/**
 * Returns whether any of the passed in params are truthy
 */
export const any = (...params) => params.some(p => Boolean(p));
/**
 * Returns whether the supplied value is one of the supplied values
 */
export const oneOf = (value, ...values) => values.some(v => v === value);

export const getDeepValue = (key, obj) =>
    key.split('.')
        .reduce((accumulator, field) =>
            accumulator[field] || '', obj);
